/* eslint-disable global-require */
module.exports = ['subscription.index.m27'];
